// Botanical hemlock sprig — decorative SVG motif used across the site.
export const Sprig = ({ className = "", strokeWidth = 1 }) => (
  <svg
    viewBox="0 0 120 320"
    fill="none"
    className={className}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60 8 C60 8 60 160 60 312"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    {Array.from({ length: 13 }).map((_, i) => {
      const y = 30 + i * 21;
      const len = 40 - Math.abs(i - 6) * 2.4;
      return (
        <g key={i}>
          <path
            d={`M60 ${y} C ${60 - len * 0.5} ${y - 2}, ${60 - len} ${y - 12}, ${60 - len} ${y - 20}`}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          <path
            d={`M60 ${y} C ${60 + len * 0.5} ${y - 2}, ${60 + len} ${y - 12}, ${60 + len} ${y - 20}`}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        </g>
      );
    })}
  </svg>
);
